import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import {
  MutationStatus,
  MutationUpdateTenantAccountAcceptedPaymentTypesArgs,
  UpdateTenantAccountAcceptedPaymentTypesInput,
} from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPDATE_TENANT_ACCOUNT_ACCEPTED_PAYMENT_TYPES = gql`
  mutation updateTenantAccountAcceptedPaymentTypes($input: UpdateTenantAccountAcceptedPaymentTypesInput!) {
    updateTenantAccountAcceptedPaymentTypes(input: $input) {
      code
      message
      error
    }
  }
`;

export const mutationUpdateTenantAccountAcceptedPaymentTypes = async (
  client: ApolloClient<NormalizedCacheObject>,
  tenantId: string,
  input: UpdateTenantAccountAcceptedPaymentTypesInput,
): Promise<MutationStatus | undefined> => {
  const baseHeaders = await getStandardHeaders(true);
  const headers = { ...baseHeaders, 'x-aptean-tenant': tenantId };
  const { data, errors } = await client.mutate<
    { updateTenantAccountAcceptedPaymentTypes: MutationStatus },
    MutationUpdateTenantAccountAcceptedPaymentTypesArgs
  >({
    variables: { input },
    mutation: MUTATION_UPDATE_TENANT_ACCOUNT_ACCEPTED_PAYMENT_TYPES,
    context: { headers },
  });

  if (errors && errors.length > 0) {
    errors.forEach(error => console.error(error));
    throw new Error('An error has occurred during the accepted payment types update.');
  }

  return data?.updateTenantAccountAcceptedPaymentTypes;
};
